module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.label_titulo) + " Atendimentos")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos distribuidos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_primeira_original
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos disponíveis")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_primeira_alterada
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.label_acao == 'bloquear') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Atendimentos bloqueados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_primeira_bloqueada),
      expression: "dados.quantidade_primeira_bloqueada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.dados.quantidade_primeira_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_primeira_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Retornos distribuidos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_retorno
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Retornos disponíveis")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_retorno_alterada
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.label_acao == 'bloquear') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Retornos bloqueados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_retorno_bloqueada),
      expression: "dados.quantidade_retorno_bloqueada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.dados.quantidade_retorno_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_retorno_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais distribuidos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_local
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group disable"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais disponíveis")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.dados.quantidade_local_alterada
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.label_acao == 'bloquear') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Locais bloqueados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dados.quantidade_local_bloqueada),
      expression: "dados.quantidade_local_bloqueada",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.dados.quantidade_local_bloqueada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_local_bloqueada", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "tag": "a"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-606ab97a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/distribuicoes/atendimentos/form.vue
// module id = 854
// module chunks = 0